import { SIGN_OUT } from 'store/auth/actions';
import {
  TaskDetailsState,
  TasksAssignedDefaultFilter,
  TasksAssignedDefaultFilterOptions,
} from 'types/Tasks';
import { createReducer } from 'typesafe-actions';
import {
  doTasksAssignedFilterOptionsLoad,
  doTasksAssignedFilterOptionsLoadFailure,
  doTasksAssignedFilterOptionsLoadSuccess,
  doTaskAssignedDetailsLoadFailure,
  doTaskAssignedDetailsLoadSuccess,
  doTasksAssignedDetailsLoad,
  doTasksAssignedLoad,
  doTasksAssignedLoadFailure,
  doTasksAssignedLoadSuccess,
  doTasksAssignedSetFilter,
  doTasksAssignedClearDraftFilterOptions,
  doTasksAssignedDetailsClose,
} from './actions';
import { TasksState } from './types';

const createEmptyTaskDetailsState = (): TaskDetailsState => ({
  isLoading: false,
  error: null,
  id: null,
  item: null,
});

const initialState: TasksState = {
  tasksAssigned: {
    items: [],
    selectedId: null,
    dueGroups: [],
    isLoading: false,
    isLoaded: false,
    filter: TasksAssignedDefaultFilter,
    filterOptions: TasksAssignedDefaultFilterOptions,
    filterOptionsDraft: null,
    filterOptionsLoadStatus: null,
    taskDetails: createEmptyTaskDetailsState(),
  },
};

export const tasksReducer = createReducer(initialState)
  .handleAction(SIGN_OUT.success, () => initialState)
  .handleAction(doTasksAssignedLoad, (state, action) => ({
    ...state,
    tasksAssigned: action.payload.showBlockingLoader
      ? state.tasksAssigned
      : {
          ...state.tasksAssigned,
          isLoading: true,
          isLoaded: false,
          filter: action.payload.filter
            ? { ...state.tasksAssigned.filter, ...action.payload.filter }
            : state.tasksAssigned.filter,
          error: undefined,
        },
  }))
  .handleAction(doTasksAssignedLoadSuccess, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      items: action.payload.tasks,
      dueGroups: action.payload.dueGroups,
      isLoading: false,
      isLoaded: true,
      error: undefined,
    },
  }))
  .handleAction(doTasksAssignedLoadFailure, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      isLoading: false,
      isLoaded: !!action.payload.error,
      error: action.payload.error,
    },
  }))
  .handleAction(doTasksAssignedSetFilter, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      filter: action.payload,
    },
  }))
  .handleAction(doTasksAssignedFilterOptionsLoad, (state) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      filterOptionsLoadStatus: 'loading',
    },
  }))
  .handleAction(doTasksAssignedClearDraftFilterOptions, (state) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      filterOptionsDraft: null,
    },
  }))
  .handleAction(doTasksAssignedFilterOptionsLoadSuccess, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      filterOptions: !action.payload.draft
        ? action.payload.filterOptions
        : state.tasksAssigned.filterOptions,
      filterOptionsDraft: action.payload.draft
        ? action.payload.filterOptions
        : state.tasksAssigned.filterOptionsDraft,
      filterOptionsLoadStatus: 'loaded',
    },
  }))
  .handleAction(doTasksAssignedFilterOptionsLoadFailure, (state) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      filterOptionsLoadStatus: 'error',
    },
  }))
  .handleAction(doTasksAssignedDetailsLoad, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      taskDetails: {
        ...createEmptyTaskDetailsState(),
        id: action.payload.taskId,
        isLoading: true,
      },
    },
  }))
  .handleAction(doTaskAssignedDetailsLoadSuccess, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      taskDetails: {
        item: action.payload.task,
        id: action.payload.task.id,
        isLoading: false,
        error: null,
      },
    },
  }))
  .handleAction(doTaskAssignedDetailsLoadFailure, (state, action) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      taskDetails: {
        ...createEmptyTaskDetailsState(),
        isLoading: false,
        error: action.payload.error,
      },
    },
  }))
  .handleAction(doTasksAssignedDetailsClose, (state) => ({
    ...state,
    tasksAssigned: {
      ...state.tasksAssigned,
      taskDetails: {
        ...createEmptyTaskDetailsState(),
      },
    },
  }));
